/**
 * Application configuration
 * Centralized place for application settings and constants
 */

export const appConfig = {
  /**
   * Trial period configuration
   */
  trial: {
    /**
     * Number of days for the trial period
     */
    periodDays: 30,
  },
};

export default appConfig;
